export const columnDesc = {
    "Detailed View": {
        "Qty at risk": "Material shortfall quantity (Demand minus Total Supply).",
        "Impacted CBU Count": "Total count of CBUs that are linked to the impacted material.",
        "Impacted CBU QTY(TO)": "Total CBU production quantity (tonnes) affected by the shortage.",
        "Days to Impact": "Number of days remaining before the material shortage impacts production.",
        "Action Week": "Week within which action must be completed to avoid a production miss.",
        "Lead Time(Min-Max)": "Min-Max vendor lead time observed from actual GRN receipts",
        "Alert Ageing": "Number of days since the alert was first raised.",
        "Week": "Week in which the shortage is expected to occur.",
        "Bottleneck RM": "Material identified as the primary constraint for one or more CBUs.",
    },
    "MAI View": {
        "JIT / Non-JIT": "Indicates whether the material is sourced Just-In-Time (JIT) or stocked (Non-JIT).",
        "Lead Time(Min-Max)": "Min-Max vendor lead time observed from actual GRN receipts",
        "Demand": "Total material quantity required for production at the site for that week.",
        "MAI % (Physical)": "(Physical Stock Available ÷ Material Requirement) × 100. (Considers only on-hand inventory)",
        "MAI % (Total)": "((Physical Stock + Inbound POs + Stock Transfers) ÷ Material Requirement) × 100. (Includes all confirmed supply sources)",
        "Norm Days": "The target inventory coverage in days, that should be maintained for a material.",
        "Physical Stock (Qty)": "Quantity of physical stock currently available.",
        "Consumption": "Quantity of material consumed for production.",
        "Unrestricted stock": "Stock immediately available for production use.",
        "Inter-unit transfer view": "Quantity expected through internal stock transfers from other factories.",
        "Past Due PO": "Open PO quantity overdue and not yet received.",
        "N-7": "Open PO quantity overdue by more than 7 days.",
        "N-30": "Open PO quantity overdue by more than 30 days.",
        "N-180": "Open PO quantity overdue by more than 180 days.",
        "Stock to Norm %": "Current stock as a percentage of the required stock norm.",
        "Stock Cover (Days)": "Number of days current stock will last before stock is consumed against demand.",
        "Physical Stock (INR)": "Value of physical stock currently available (INR).",
        "Future Open PO": "Total open purchase order quantity scheduled for future receipt.",
        "Bottleneck RM": "Material identified as the primary constraint for one or more CBUs.",
        "Total":"Total Stock = Unrestricted stock + Stock in quality + STV stock"
    },
    "FG Coverage": {
        "Physical FG Coverage": "Percent of demand that can be covered by current FG stock.",
        "Total FG Coverage": "Percent of demand that can be covered by current FG stock and confirmed incoming supply."
    },
    "OpenPO Details": {
        "Past Due PO": "Open PO quantity overdue and not yet received.",
        "Past Due PO (N-7)": "Open PO quantity overdue by more than 7 days.",
        "Past Due PO (N-30)": "Open PO quantity overdue by more than 30 days.",
        "Past Due PO (N-180)": "Open PO quantity overdue by more than 180 days.",
    },
    "Norm Alert": {
        "Bottleneck RM": "Material identified as the primary constraint for one or more CBUs.",
        "Stock Cover (Days)": "Number of days current stock will last before stock is consumed against demand.",
        "Physical Stock (INR)": "Value of physical stock currently available (INR).",
        "% Stock to norm coverage": "Current stock as a percentage of the required stock norm.",
    }
};
